import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContentSpinner from '../../../shared/Spinner/Spinner';
import Loader from '../../../shared/Events/Loader/Loader';
import Table from '../Table/Table';
import PopularEvents from '../PopularEvents/PopularEvents';
import { EVENT_FILTER_OPTIONS, saveEventFilters } from '../../../../constants/event-filters';
import useOnScreen from '../../../../hooks/useOnScreen';
import {
    clearPopularEvents,
    getEvents,
    getPopularEvents,
} from '../../../../store/actions/sportEvents';
import ConnectionError from '../../ConnectionError/ConnectionError';

const RegularEvents = () => {
    const dispatch = useDispatch();
    const { ref, isIntersecting: isLoadMoreVisible } = useOnScreen();

    const { isSocketConnected, connectionCounter } = useSelector(state => state.socket);
    const {
        events,
        isFetching,
        isPaginating,
        isFiltersFetching,
        hasNextPage,
        sortType,
        total,
        isLive,
        pageOffset,
        filters,
        shouldUpdateEvents,
        sportRefId,
    } = useSelector(state => state.sportEvents);

    const renderEvents = () => {
        if (sortType === EVENT_FILTER_OPTIONS.orders.byLeague.id) {
            return (
                <>
                    {events.map(season => {
                        return (
                            <Table
                                key={season.id}
                                categoryName={season.categoryName}
                                countryCode={season.countryCode}
                                leagueName={season.seasonName}
                                events={season.events}
                            />
                        );
                    })}
                </>
            );
        } else if (
            sortType === EVENT_FILTER_OPTIONS.orders.byTime.id ||
            sortType === EVENT_FILTER_OPTIONS.orders.byMbn.id
        ) {
            return <Table events={events} />;
        }
    };

    useEffect(() => {
        if (
            !isLoadMoreVisible ||
            isFetching ||
            isFiltersFetching ||
            isPaginating ||
            !hasNextPage ||
            !isSocketConnected ||
            total === 0
        )
            return;

        dispatch(getEvents({ pageOffset }));
    }, [isLoadMoreVisible]);

    useEffect(() => {
        if (Object.keys(filters).length === 0 || !shouldUpdateEvents) return;

        dispatch(getEvents({ pageOffset: 0 }));
        saveEventFilters({ filters, sportRefId, isLive });
    }, [filters]);

    useEffect(() => {
        if (isLive || !sportRefId) return;

        dispatch(getPopularEvents());

        return () => {
            dispatch(clearPopularEvents());
        };
    }, [sportRefId, isLive]);

    return (
        <>
            {isFetching || isFiltersFetching || !connectionCounter ? (
                <ContentSpinner />
            ) : isSocketConnected ? (
                <>
                    {!isLive && <PopularEvents />}
                    {renderEvents()}
                </>
            ) : (
                <ConnectionError />
            )}
            {isPaginating ? <Loader /> : null}
            <button className={'v-hidden h-0'} ref={ref}>
                Load More
            </button>
        </>
    );
};

export default RegularEvents;
